import { AdjustmentRuleType, Prisma, prisma } from "client";
import { create } from "domain";
export const getAdjustmentRuleById = async (id: string) => {
  try {
    const adjustmentRule = await prisma.adjustmentRule.findFirst({
      where: {
        id: id,
      },
    });

    return adjustmentRule;
  } catch (error) {
    console.error("Error fetching adjustment rule by ID:", error);
    throw error;
  }
};
export const getAdjustmentRules = async (
  eventId: string,
  page: number = 1,
  pageSize: number = 10,
  search?: string,
  type?: AdjustmentRuleType
) => {
  const skip = (page - 1) * pageSize;
  const take = pageSize;
  let whereClause: Prisma.AdjustmentRuleWhereInput = {
    eventId: eventId
  };
  if (search) {
    whereClause = {
      AND: [
        whereClause,
        {
          OR: [
            { name: { contains: search, mode: "insensitive" } }
          ],
        },
      ],
    };
  }
  if (type) {
    whereClause = {
      AND: [
        whereClause,
        { type: { equals: type } },
      ],
    };
  }
  const [adjustmentRule, total] = await Promise.all([
    prisma.adjustmentRule.findMany({
      include: {
        chargeAdjustments: true,
        discountAdjustments: true
      },
      where: whereClause,
      orderBy: {
        id: "desc",
      },
      skip: skip,
      take: take,

    }),
    prisma.adjustmentRule.count({
      where: whereClause,
    }),
  ]);
  const hasNextPage = skip + take < total;
  return {
    adjustmentRule,
    hasNextPage,
    total,
  };
};

export const createAdjustmentRule = async (
  data: {
    adjustmentRulePayload: Prisma.AdjustmentRuleCreateInput;
    adjustmentTypePayload:
    | Prisma.DiscountAdjustmentCreateInput[]
    | Prisma.ChargeAdjustmentCreateInput[];
  },
  eventId: string
) => {
  try {
    const { adjustmentRulePayload, adjustmentTypePayload } = data;

    const adjustableRuleType =
      adjustmentRulePayload.type === AdjustmentRuleType.DISCOUNT
        ? "discountAdjustments"
        : "chargeAdjustments";
    if ("code" in adjustmentTypePayload && adjustmentTypePayload?.code) {
      const checkIfCodeExists = await prisma.discountAdjustment.findFirst({
        where: {
          code: adjustmentTypePayload.code,
          eventId,
        },
      });
      if (checkIfCodeExists) {
        throw new Error("Code already exists");
      }
    }
    const payload = {
      ...adjustmentRulePayload,
      [adjustableRuleType]: {
        create: {
          ...adjustmentTypePayload,
          event: {
            connect: {
              id: eventId,
            },
          },
        },
      },
      event: { connect: { id: eventId } },
    };

    return await prisma.adjustmentRule.create({
      data: {
        ...payload,
        event: {
          connect: {
            id: eventId,
          },
        },
      },
    });
  } catch (error) {
    console.error("Error creating adjustment rule:", error);
    throw error;
  }
};

export const updateAdjustmentRule = async (
  id: string,
  { adjustmentRulePayload, adjustmentTypePayload }: {
    adjustmentRulePayload: Prisma.AdjustmentRuleUpdateInput;
    adjustmentTypePayload: Prisma.DiscountAdjustmentUpdateInput[] | Prisma.ChargeAdjustmentUpdateInput[];
  }
) => {
  try {
    const updateAdjustment = adjustmentRulePayload.type === AdjustmentRuleType.DISCOUNT
      ? prisma.discountAdjustment.updateMany({ where: { adjustmentRuleId: id }, data: adjustmentTypePayload })
      : prisma.chargeAdjustment.updateMany({ where: { adjustmentRuleId: id }, data: adjustmentTypePayload });
    await updateAdjustment;
    return prisma.adjustmentRule.update({
      where: { id },
      data: adjustmentRulePayload,
    });
  } catch (error) {
    console.error("Error updating adjustment rule:", error);
    throw error;
  }
};
